import {
  getExecutions,
  getSchedules,
  getCodes,
  getResults,
  getLogs,
  modifySchedule,
  checkSchedule,
} from '../../api/analytics-api';

// Helper to curry in the JWT from state and then call the provided api function and dispatch
// to its well-named action
const fetchBuilder =
  (apiFunc, name, extras = {}) =>
  (...args) =>
  (dispatch, getState) => {
    const {
      user: { jwt },
    } = getState();
    return apiFunc(...[jwt].concat(args)).then((data) => {
      const action = {
        type: `SET_${name}`,
        data,
      };
      // pass through any arguments defined by 'extras' to the action
      Object.entries(extras).forEach(([k, v]) => (action[k] = args[v]));
      dispatch(action);
    });
  };

export const fetchExecutions = fetchBuilder(getExecutions, 'EXECUTIONS');

export const fetchNextExecutions = (dispatch, getState) => {
  const {
    analytics: {
      executions: { nextPage },
    },
  } = getState();
  dispatch(fetchExecutions(nextPage));
};

export const fetchCodes = fetchBuilder(getCodes, 'CODES');

export const fetchSchedules = fetchBuilder(getSchedules, 'SCHEDULES');

export const modifyScheduleActionCreator = (id, changes) => (dispatch, getState) => {
  const {
    user: { jwt },
    analytics: {
      schedules: { byId },
    },
  } = getState();
  const schedule = byId[id];
  if (!schedule) return Promise.reject(new Error(`Invalid schedule id ${id}`));
  const updated = {
    ...schedule,
    ...changes,
    id,
  };
  return modifySchedule(jwt, updated).then(() => dispatch(fetchSchedules()));
};

export const checkScheduleActionCreator =
  (id, thorough = true) =>
  (dispatch, getState) => {
    const {
      user: { jwt },
      analytics: {
        schedules: { byId },
      },
    } = getState();
    const schedule = byId[id];
    if (!schedule) return Promise.reject(new Error(`Invalid schedule id ${id}`));
    return checkSchedule(jwt, schedule, thorough).then(() => {
      dispatch(fetchSchedules());
      dispatch(fetchExecutions());
    });
  };

// both of these require the execution id as the first argument

export const fetchResults = fetchBuilder(getResults, 'EXEC_RESULTS', { execId: 0 });

export const fetchLogs = fetchBuilder(getLogs, 'EXEC_LOGS', { execId: 0 });
